export enum PostMessageEvent {
  AppInstalled = "app_installed",
  AppPurchased = "app_purchased",
  AppRemoved = "app_removed",
  AppEvent = "app_event",
  Loaded = "loaded",
  MarketplaceCartUpdate = "marketplace_cart_update",
  Navigate = "navigate",
  RouteChange = "route_change",
}
